import { path } from 'ramda';

import config from '../generated/config';

const getApiUrl = apiName => path(['api', apiName], config);

const getQuery = name => path(['queryname', name], config);

export const cepUrl = getApiUrl('cep');

export const shoppingClubUrl = getApiUrl('shoppingClub');

export const customerv6Url = getApiUrl('customerv6');

export const customerv6Url_NPF = getApiUrl('customerv6NPF');

export const customerTokenUrl = getApiUrl('customerToken');

export const loginInfoUrl = `${getApiUrl('restql')}/simple-login${getQuery(
  'customerAndRegionAndPrime'
)}`;

export const spaceyUrl = getApiUrl('spacey');

export const financeUrl = getApiUrl('finance');

export const createAuthenticationUrl = captchaResponse => {
  if (captchaResponse) {
    return `${getApiUrl(
      'customerToken'
    )}?captcha_sitetype=invisible&captcha_response=${captchaResponse}`;
  }
  return getApiUrl('customerToken');
};

export const sendPasswordUpdateEmailUrl =
  config.brand === 'aemp' || config.brand === 'prtl'
    ? `${customerv6Url}/buyer/actions/send-password-update-email`
    : `${customerv6Url}/actions/send-password-update-email`;

export const createPasswordRetrievalUrl = email =>
  `${getApiUrl('account')}/${email}/password/actions/retrieve`;

export const createChangePasswordUrl = captchaResponse => {
  const baseUrl =
    config.brand === 'aemp' || config.brand === 'prtl'
      ? `${customerv6Url}/buyer/actions/password-update`
      : `${customerv6Url}/actions/password-update`;

  if (captchaResponse) {
    return `${baseUrl}?captcha_response=${captchaResponse}`;
  }

  return baseUrl;
};

export const createChangeLoginUrl = captchaResponse => {
  const baseUrl = `${customerv6Url}/actions/login-update`;

  if (captchaResponse) {
    return `${baseUrl}?captcha_response=${captchaResponse}`;
  }

  return baseUrl;
};

export const createGuestAuthenticationUrl = cpf =>
  `${getApiUrl('guest')}/${cpf.replace(/\D/g, '')}/authenticate`;

export const createTelemarketerAuthenticationUrl = email => `${getApiUrl('telemarketer')}/${email}`;

export const createTelemarketerCustomerAuthenticationUrl = () =>
  `${getApiUrl('telemarketer')}/actions/authenticate-customer`;

export const createTelemarketerBuyerAuthenticationUrl = () =>
  `${getApiUrl('telemarketer')}/actions/authenticate-buyer`;

export const createGenerateAccessTokenUrl = () => getApiUrl('customerToken');

export const createCustomerRegisterUrl = captchaResponse => {
  const baseUrl = customerv6Url;
  if (captchaResponse) {
    return `${baseUrl}?captcha_response=${captchaResponse}`;
  }
  return baseUrl;
};

export const updateSaikaExpectationUrl = () => `${getApiUrl('saika')}/expectation`;

export const updateSaikaFactUrl = () => `${getApiUrl('saika')}/fact`;
